<template>
  <div>
    <!-- wrapper(s) -->
    <div class="wrapper">
      <Header class="header" data-title="비밀번호 찾기" :type="'empty'" :val="headerTitle"></Header>
      <div class="container">
        <!-- content(s) -->
        <div id="content">
          <section>
            <div class="guideMsg">
              <p class="txtL">
                웰몰 회원님의 비밀번호를 찾기 위해
                <br />
                회원가입시 입력한 본인명의의 핸드폰을 통한 문자인증이 필요합니다.
              </p>
            </div>

            <ValidationObserver ref="form">
              <div class="formArea">
                <span class="label">아이디</span>
                <ValidationProvider name="아이디" rules="required|userId" vid="userId">
                  <input type="text" id="ipt1_1" class="ipt" title="아이디 입력" value="" v-model="userId" />
                </ValidationProvider>

                <span class="label">이름</span>
                <ValidationProvider name="이름" rules="required" vid="userName">
                  <input type="text" id="ipt4" class="ipt" title="이름 입력" value="" v-model="userName" />
                </ValidationProvider>

                <span class="label">생년월일</span>
                <div class="setBirth">
                  <input
                    type="tel"
                    class="ipt"
                    maxlength="4"
                    title="생년월일 년도 4자리"
                    placeholder="1990"
                    v-model="year"
                    v-onlyNum
                    nextTarget="mm"
                    v-skipOfMax
                  />
                  <span class="sign" aria-hidden="true">/</span>
                  <input
                    type="tel"
                    class="ipt"
                    maxlength="2"
                    title="생년월일 월 2자리"
                    placeholder="01"
                    v-model="month"
                    v-onlyNum
                    nextTarget="dd"
                    v-skipOfMax
                    id="mm"
                  />
                  <span class="sign" aria-hidden="true">/</span>
                  <input type="tel" class="ipt" maxlength="2" title="생년월일 일 2자리" placeholder="01" v-model="day" v-onlyNum id="dd" />
                </div>

                <ValidationProvider name="생년월일" rules="required|birth" vid="birth">
                  <input type="hidden" id="birth" class="ipt" v-model="birth" />
                </ValidationProvider>

                <span class="label">휴대폰번호</span>

                <ValidationProvider name="휴대폰번호" rules="required|cellNum" vid="cellNum" ref="cellNum">
                  <!--
                  <div class="setPhone">
                    <input
                      type="tel"
                      id="phone_2"
                      class="ipt"
                      title="휴대폰 번호 입력"
                      placeholder="' - ' 없이 입력해주세요."
                      value=""
                      v-model="cellNum"
                      v-onlyNum
                    />
                    <button type="button" class="btn_s round s" @click="sendAuthNumber">
                      {{ authButtonTitle }}
                    </button>
                  </div>
                  -->
                  <div class="setAddr uiAct">
                    <div class="iptWrap">
                      <input
                        type="tel"
                        id="phone_2"
                        class="ipt notDel uiAct"
                        title="휴대폰 번호 입력"
                        placeholder="' - ' 없이 입력해주세요."
                        value=""
                        v-model="cellNum"
                        v-onlyNum
                      />
                    </div>
                    <button type="button" class="btn_g m" @click="sendAuthNumber">{{ authButtonTitle }}</button>
                  </div>
                </ValidationProvider>
                <!--
                <div v-show="showAuth">
                    <input type="tel" id="phone_3" class="ipt addTxt" title="인증번호 입력" placeholder="" value="" v-model="authKey" v-onlyNum />
                    <span class="txt">
                      유효시간
                      <strong class="pointC1">{{ authTime | convertTimeToMS }}</strong>
                    </span>
                </div>
                -->
                <div class="uiAct" v-show="showAuth">
                  <div class="iptWrap addTxt">
                    <input
                      type="tel"
                      id="phone_3"
                      class="ipt notDel uiAct"
                      title="휴대폰 번호 입력"
                      placeholder=""
                      value=""
                      v-model="authKey"
                      v-onlyNum
                    />
                    <span class="txt">
                      <strong class="pointC1">{{ authTime | convertTimeToMS }}</strong>
                    </span>
                  </div>
                </div>
              </div>
            </ValidationObserver>

            <div class="btnArea sticky">
              <button type="button" class="btn_p" @click="changePassword" :disabled="regButtonShow">
                확인
              </button>
            </div>
          </section>
        </div>
        <!-- content(e) -->
      </div>
      <!-- container(e) -->
      <footer class="footer"></footer>
    </div>
    <!-- wrapper(e) -->

    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
</template>

<script>
import ApiService from '@/common/api.service';
// import { isEmpty } from '@/common/common.function';
import { AUTH_TIMEOUT, INPUT_INFO_CHECK } from '@/store/message.type';
import MessagePop from '@/components/popup/MessagePop';
import { isEmpty } from '@/common/common.function';

export default {
  name: 'findPwd',
  components: {
    MessagePop,
  },
  data: function() {
    return {
      headerTitle: '비밀번호 찾기',

      userId: null, // 아이디
      userName: null, // 이름
      year: null, // 년
      month: null, // 월
      day: null, // 일
      cellNum: null, // 휴대폰번호
      count: null, // 제한시간
      authTime: '180', // 인증시간
      authTimeCheck: false, // 인증 유무 true false
      authKey: null, // 인증번호 입력란
      tranId: null, // 인증번호 요청시 tranId
      authButtonTitle: '인증번호요청', // 인증번호요청버튼 텍스트
      msg: null, //modal message
      msgType: 'validation',
      messagePop: false,
      showAuth: false,

      regButtonShow: true,
    };
  },
  watch: {
    authTimeCheck: function() {
      if (this.authTimeCheck == false) {
        this.msg = AUTH_TIMEOUT;
        // this.errorCode = null;
        this.authTime = '180';
        this.authkey = null;
        this.messagePop = true;
      }
    },
    authTime() {
      if (this.authTime == 0) {
        this.authButtonTitle = '인증번호요청'; // 버튼 타이틀 초기값으로 변경
        clearInterval(this.countDown); // 카운트다운 초기화
        this.errorCode = null; // API 통해 리턴 받은 에러 코드 값 초기화
        this.authKey = null; // 인증번호 입력란 초기화
        // this.authTime = 180;
        //this.authTime = 10; // 인증번호 시간 초기화
        this.msg = AUTH_TIMEOUT; // API 서버에서도 리턴해주지만 클라이언트 쪽에서 처리하기 위해 메세지 추가
        this.messagePop = true;
      }
    },
    userId() {
      this.checkInput();
    },
    userName() {
      this.checkInput();
    },
    year() {
      this.checkInput();
    },
    month() {
      this.checkInput();
    },
    day() {
      this.checkInput();
    },
    cellNum() {
      this.checkInput();
    },
    authKey() {
      this.checkInput();
    },
  },
  computed: {
    birth: function() {
      return this.year + this.month + this.day;
    },
  },
  methods: {
    //인증번호 요청
    sendAuthNumber: async function() {
      this.$refs.cellNum.validate().then(async success => {
        if (!success.valid || this.userId == null || this.birth == '' || this.userName == '') {
          this.msg = INPUT_INFO_CHECK;
          this.messagePop = true;
        } else {
          // API 호출
          await ApiService.service('POST', 'common/sms/auth', {
            request: {
              cellNum: this.cellNum,
              userId: this.userId,
              birth: this.birth.substring(2),
              userName: this.userName,
              sendType: 'SPSM0003',
            },
            serviceType: 'app',
          })
            .then(({ data }) => {
              if (data.isSucceed) {
                console.log(data.result.authKey);
                console.log(data.result.transactionId);
                // TODO 모바일 테스트용
                this.authKey = data.result.authKey;

                // TODO 자동입력 로직 추가 해야함
                this.authTimeCheck = true;
                this.showAuth = true;
                this.tranId = data.result.transactionId;

                this.authButtonTitle = '재요청';
                this.authTime = 180; //시간
                clearInterval(this.countDown);
                this.countDown = setInterval(() => {
                  this.authTime--;
                }, 1000);
              } else {
                this.msg = data.error;
                this.messagePop = true;
              }
            })
            .catch(response => {
              console.log(response);
            });
        }
      });
    },
    changePassword: function() {
      //인증번호 체크 및 validation
      this.$refs.form.validate().then(async success => {
        if (!success) {
          this.msg = INPUT_INFO_CHECK;
          this.messagePop = true;
        } else {
          await ApiService.service('POST', 'common/sms/auth/check', {
            request: {
              authKey: this.authKey,
              birth: this.birth.substring(2),
              cellNum: this.cellNum,
              smsType: 'SPSM0003',
              tranId: this.tranId,
              userId: this.userId,
              userName: this.userName,
            },
            serviceType: 'web/app',
          })
            .then(({ data }) => {
              if (data.isSucceed) {
                if (data.result.snsLoginYn == 'Y') {
                  this.msg =
                    `<b style="font-size: 15px;">회원정보확인</b><br>고객님께서는 <span style="color:#ff4f0a;">[` +
                    data.result.snsKind +
                    `]</span> 서비스를 통해 가입된 정보가 확인됩니다.<br>SNS 로그인을 이용해주세요.`;
                  this.msgType = 'sns';
                  this.messagePop = true;
                } else {
                  let userInfo = {
                    userId: data.result.userId,
                    tranId: this.tranId,
                    customerId: this.userId,
                  };
                  this.$router.push({
                    name: 'changePwd',
                    params: { userInfo: userInfo },
                  });
                }
              } else {
                this.errorCode = data.errorCode;
                if (this.errorCode == '-10016') {
                  this.$router.push('findPwdResult'); // 정보를 찾지 못할경우 페이지 이동
                } else {
                  this.msg = data.error;
                  this.messagePop = true;
                }
              }
            })
            .catch(({ response }) => {
              console.log('error : ' + response);
            });
        }
      });
    },
    close: function() {
      this.messagePop = false;
      if (this.msgType == 'sns') {
        this.$router.replace({ name: 'login' });
      }
    },
    checkInput() {
      if (
        !isEmpty(this.userId) &&
        !isEmpty(this.userName) &&
        !isEmpty(this.year) &&
        !isEmpty(this.month) &&
        !isEmpty(this.day) &&
        !isEmpty(this.cellNum) &&
        !isEmpty(this.authKey)
      ) {
        this.regButtonShow = false;
      } else {
        this.regButtonShow = true;
      }
    },
  },
};
</script>
